import { safeLinkUrl } from "../announcements/RemoteAnnouncementContent";

// ─────────────────────────────────────────────────────────────────────────────
// Reglas puras de las Novedades que comparten el portal del comercio y el
// editor de /plataforma. Sin React ni i18n: las etiquetas son claves en
// español que la vista pasa por t().
// ─────────────────────────────────────────────────────────────────────────────

export const NEWS_CATEGORIES = {
  new: { label: "Nuevo", tone: "success" },
  improvement: { label: "Mejora", tone: "info" },
  notice: { label: "Aviso", tone: "warning" },
};

export const NEWS_CATEGORY_KEYS = Object.keys(NEWS_CATEGORIES);

/**
 * Ruta interna del portal: una sola `/` inicial, sin esquema ni host, con query
 * y fragmento simples (`/home/faqs#faq-<id>`). Es la MISMA regla que valida el
 * backend (`product-news-content.policy.ts`); acá es la barrera al pintar, por
 * si algo llegó por otra vía.
 */
const INTERNAL_PATH =
  /^\/(?![/\\])[A-Za-z0-9\-._~/]*(\?[A-Za-z0-9\-._~=&%]*)?(#[A-Za-z0-9\-_]*)?$/;

export function isInternalPortalPath(url) {
  const value = String(url ?? "");
  if (!value || value.length > 2048 || value.includes("..")) return false;
  return INTERNAL_PATH.test(value);
}

/**
 * A dónde lleva el botón de una novedad.
 *  - `internal`: ruta del portal, se abre con el router en la misma pestaña;
 *  - `external`: https, mailto o tel, en otra pestaña sin `opener`;
 *  - null: no se pinta el botón.
 */
export function ctaTargetOf(url) {
  if (isInternalPortalPath(url)) return { kind: "internal", path: url };
  const href = safeLinkUrl(url);
  return href ? { kind: "external", href } : null;
}

/** Ids de las novedades del panel que este usuario todavía no vio. */
export function unseenIdsOf(items) {
  return (items ?? []).filter((item) => item && !item.read).map((item) => item.id);
}
